module.exports = __webpack_public_path__ + "static/media/search-icon.71331e0e.svg";